/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Scope_Output5Inputs */

const en_svc_ai_agent_development_scope_output5 = /** @type {(inputs: Svc_Ai_Agent_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autonomy contract`)
};

const ar_svc_ai_agent_development_scope_output5 = /** @type {(inputs: Svc_Ai_Agent_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عقد الاستقلالية`)
};

const bn_svc_ai_agent_development_scope_output5 = /** @type {(inputs: Svc_Ai_Agent_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অটোনমি কন্ট্রাক্ট`)
};

const de_svc_ai_agent_development_scope_output5 = /** @type {(inputs: Svc_Ai_Agent_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autonomievertrag`)
};

const es_svc_ai_agent_development_scope_output5 = /** @type {(inputs: Svc_Ai_Agent_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrato de autonomía`)
};

const fr_svc_ai_agent_development_scope_output5 = /** @type {(inputs: Svc_Ai_Agent_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrat d'autonomie`)
};

const pt_svc_ai_agent_development_scope_output5 = /** @type {(inputs: Svc_Ai_Agent_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrato de autonomia`)
};

const zh_svc_ai_agent_development_scope_output5 = /** @type {(inputs: Svc_Ai_Agent_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自治合约`)
};

const tr_svc_ai_agent_development_scope_output5 = /** @type {(inputs: Svc_Ai_Agent_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özerklik sözleşmesi`)
};

const ru_svc_ai_agent_development_scope_output5 = /** @type {(inputs: Svc_Ai_Agent_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контракт автономии`)
};

const pl_svc_ai_agent_development_scope_output5 = /** @type {(inputs: Svc_Ai_Agent_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umowa o autonomii`)
};

/**
* | output |
* | --- |
* | "Autonomy contract" |
*
* @param {Svc_Ai_Agent_Development_Scope_Output5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_scope_output5 = /** @type {((inputs?: Svc_Ai_Agent_Development_Scope_Output5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Scope_Output5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_scope_output5(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_scope_output5(inputs)
	if (locale === "de") return de_svc_ai_agent_development_scope_output5(inputs)
	if (locale === "es") return es_svc_ai_agent_development_scope_output5(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_scope_output5(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_scope_output5(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_scope_output5(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_scope_output5(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_scope_output5(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_scope_output5(inputs)
	return en_svc_ai_agent_development_scope_output5(inputs)
});
export { svc_ai_agent_development_scope_output5 as "svc_ai-agent-development_SCOPE_output" }